import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { PostHogProvider } from 'posthog-js/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={process.env.REACT_APP_POSTHOG_KEY}
      options={{
        api_host: process.env.REACT_APP_POSTHOG_HOST,
        ui_host: process.env.REACT_APP_POSTHOG_UI_HOST || 'https://us.posthog.com',
        defaults: '2026-05-30',
        person_profiles: 'identified_only',
        capture_pageviews: true,
        capture_pageleaves: true,
        autocapture: true,
        capture_exceptions: true,
        debug: process.env.NODE_ENV === 'development',
        loaded: (posthog) => {
          if (process.env.NODE_ENV === 'development') posthog.debug();
        }
      }}
    >
      <App />
    </PostHogProvider>
  </React.StrictMode>
);